/**
 * Forms
 */

// translation variables

if ($('html').attr('lang') == 'en-US') {

    var messages = {
        phone: {
            minlength: 'Please enter 10 digits',
            maxlength: 'Please enter 10 digits'
        },
        lastName: {
            required: 'Please enter your last name'
        },
        firstName: {
            required: 'Please enter your first name'
        },
        email: {
            required: 'Please enter your email'
        },
    }

} else if ($('html').attr('lang') == 'es-US') {


    $.extend($.validator.messages, {
        required: 'Este campo es obligatorio.',
        remote: 'Por favor, rellena este campo.',
        email: 'Por favor, escribe una dirección de correo válida.',
        url: 'Por favor, escribe una URL válida.',
        date: 'Por favor, escribe una fecha válida.',
        dateISO: 'Por favor, escribe una fecha (ISO) válida.',
        number: 'Por favor, escribe un número válido.',
        digits: 'Por favor, escribe sólo dígitos.',
        creditcard: 'Por favor, escribe un número de tarjeta válido.',
        equalTo: 'Por favor, escribe el mismo valor de nuevo.',
        extension: 'Por favor, escribe un valor con una extensión aceptada.',
        maxlength: $.validator.format('Por favor, no escribas más de {0} caracteres.'),
        minlength: $.validator.format('Por favor, no escribas menos de {0} caracteres.'),
        rangelength: $.validator.format('Por favor, escribe un valor entre {0} y {1} caracteres.'),
        range: $.validator.format('Por favor, escribe un valor entre {0} y {1}.'),
        max: $.validator.format('Por favor, escribe un valor menor o igual a {0}.'),
        min: $.validator.format('Por favor, escribe un valor mayor o igual a {0}.'),
        nifES: 'Por favor, escribe un NIF válido.',
        nieES: 'Por favor, escribe un NIE válido.',
        cifES: 'Por favor, escribe un CIF válido.'
    });

    var messages = {
        phone: {
            minlength: 'Por favor, ingrese 10 dígitos',
            maxlength: 'Por favor, ingrese 10 dígitos'
        }
    }
}

if ($('.js-form').length) {
    $.validator.methods.email = function (value, element) {
        return this.optional(element) || /^\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b$/i.test(value);
    }
    $('.js-form').each(function () {
        $(this).validate({
            errorClass: 'js-form-error',
            validClass: 'js-form-valid',
            errorPlacement: function (error, element) {
                if (element.hasClass('js-hero-search-input')) {
                    $('.js-form-search-error').html(error);
                } else if (element.attr('type') == 'checkbox' || element.attr('name') == 'checkbox') {
                    let errorContainer = element.closest('.awsm-job-form-checkbox').find('.js-error-checkbox');
                    error.appendTo(errorContainer);
                } 
                else {
                    error.insertAfter(element);
                }
                
            },
            submitHandler: function (form) {
                $(form).addClass('js-form--loading');
                $(form).find('[type=submit]').prop('disabled', true);
                form.submit(); 
            }
        });

    });

    if ($('[data-message-required]').length) {
        $('[data-message-required]').each(function () {
            $(this).rules('add', {
                messages: {
                    required: $(this).data('message-required')
                }
            });
        });
    }

    if ($('.js-valid-phone-number').length) {
        $('.js-valid-phone-number').each(function () {
            $(this).rules('add', {
                minlength: 12,
                maxlength: 12,
                messages: {
                    minlength: messages.phone.minlength,
                    maxlength: messages.phone.maxlength
                }
            });
        });
    }
    if ($('.js-valid-first-name').length) {
        $('.js-valid-first-name').each(function () {
            $(this).rules('add', {
                required: true,
                minlength: 2,
                messages: {
                    required: messages.firstName.required
                }
            });
        });
    }

    if ($('.js-valid-last-name').length) {
        $('.js-valid-last-name').each(function () {
            $(this).rules('add', {
                required: true,
                minlength: 2,
                messages: {
                    required: messages.lastName.required
                }
            });
        });
    }
    if ($('.js-valid-address').length) {
        $('.js-valid-address').each(function () {
            $(this).rules('add', {
                required: true,
                minlength: 2,
                messages: {
                    required: messages.address.required
                }
            });
        });
    }
    if ($('.js-valid-email').length) {
        $('.js-valid-email').each(function () {
            $(this).rules('add', {
                required: true,
                minlength: 3,
                maxlength: 120,
                messages: {
                    required: messages.email.required
                }
            });
        });
    }
    if ($('.js-valid-phone').length) {
        $('.js-valid-phone').each(function () {
            $(this).rules('add', {
                required: true,
                minlength: 12,
                maxlength: 12,
                messages: {
                    required: messages.phone.required,
                    minlength: messages.phone.minlength,
                    maxlength: messages.phone.maxlength
                }
            });
        });
    }
}